/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

// production
var API_DOMAIN = 'https://mudu.tv';
var AUTH_DOMAIN = 'https://mudu.tv';
var API_DOMAIN_V2 = 'https://liveapi.mudu.tv';

/**
 * 定制功能，7.25下线
 * 定制用户的uin，强行将回放视频的打点数据用于所有回放视频播放
 */
var customForceBookmarkUin = [];

switch (window.MUDU_SERVER_ENV) {
    case 'TEST':
        API_DOMAIN = 'https://test.mudu.tv';
        AUTH_DOMAIN = 'https://test.mudu.tv';
        API_DOMAIN_V2 = 'https://testsvc-3.mudu.tv';
        break;
    case 'UAT':
        API_DOMAIN = 'https://mdl-live.uat.mudu.tv/';
        AUTH_DOMAIN = 'https://mdl-live.uat.mudu.tv/';
        API_DOMAIN_V2 = 'https://mdl-liveapi.uat.mudu.tv';
        break;
    case 'TX_PROD':
    case 'PROD':
    default:
        API_DOMAIN = 'https://mudu.tv';
        AUTH_DOMAIN = 'https://mudu.tv';
        API_DOMAIN_V2 = 'https://liveapi.mudu.tv';
}

var BASE_INFO_URL = API_DOMAIN + '/?c=activity&a=ajaxActBaseInfo';

var SIGNUP_SENDSMS_URL = API_DOMAIN + '/?c=activity&a=ajaxSendPhoneVerify';
var SIGNUP_SUBMIT_URL = API_DOMAIN + '/?c=activity&a=ajaxSaveSignupRecord';

// var TOPIC_GET_SINGLE_TOPIC_URL = `${API_DOMAIN}/?c=activity&a=ajaxGetSingleTopic`;
var TOPIC_GET_REPLY_URL = API_DOMAIN + '/?c=activity&a=ajaxGetReplies';
var TOPIC_GET_URL = API_DOMAIN + '/?c=activity&a=ajaxGetTopics';
var TOPIC_CREATE_URL = API_DOMAIN + '/?c=activity&a=ajaxCreateTopic';

var SOCIAL_LOGIN_URL = API_DOMAIN + '/?c=sociallogin&a=sdklogin';
var RELATIVE_SOCIAL_LOGIN_URL = '/?c=sociallogin&a=sdklogin';

var REDPACK_STATUS_URL = API_DOMAIN + '/?c=activity&a=ajaxGetRedpackStatus';
var REDPACK_RECORD_URL = API_DOMAIN + '/?c=activity&a=ajaxGetRedpackRecord';
var REDPACK_SNATCH_URL = API_DOMAIN + '/?c=activity&a=ajaxSnatchRedpack';

var CASH_DONATE_DETAIL_URL = API_DOMAIN + '/?c=user&a=ajaxGetDonateMessage';
var GIFT_DETAIL_URL = API_DOMAIN + '/activity.php?a=AjaxGiftDetail';
var DONATE_URL = API_DOMAIN + '/user.php?a=donate';
var RELATIVE_DONATE_URL = '/user.php?a=donate';
var FREE_GIFT_DONATE_URL = API_DOMAIN + '/user.php?a=ajaxFreePropDonate';

var PPT_GET_IMG_BY_PAGE_URL = API_DOMAIN + '/?c=document&a=ajaxGetPageImage';

// 用户授权 
var USER_AUTH_START_SESSION = AUTH_DOMAIN + '/user/api/session/start'; // 使用时尾部拼:actHashId
var USER_AUTH_GET_USER_INFO = AUTH_DOMAIN + '/user/api/user_info/'; // 去掉了 不需要了
var USER_AUTH_ANONYMOUS = AUTH_DOMAIN + '/user/api/login/anonymous'; // 匿名登录替换了新接口
var USER_AUTH_LOGIN_BY_OTHER = AUTH_DOMAIN + '/user/api/login_by_other';

var SOCIAL_LOGIN_TYPE_ARRAY = ['qq', 'weibo', 'weixin', 'openweixin', 'mingdao', 'weimob'];

var COMMENT_IMAGE_NUM_REG = /<img src='\/assets\/activity\/images\/face\/(\d+)\.png' width='18' height='18'\/>/g;
var COMMENT_TEXT_REG = /\[em_([0-9]*)\]/g;

var STREAM_MULTI_RATE = {
    'origin': '原片',
    '480p': '标清',
    '720p': '高清'
};

var MENU_TYPE = {
    DOC: 9,
    CHAT: 1
};

module.exports = {
    customForceBookmarkUin: customForceBookmarkUin,
    API_DOMAIN: API_DOMAIN,
    API_DOMAIN_V2: API_DOMAIN_V2,
    BASE_INFO_URL: BASE_INFO_URL,
    MENU_TYPE: MENU_TYPE,

    SIGNUP_SENDSMS_URL: SIGNUP_SENDSMS_URL,
    SIGNUP_SUBMIT_URL: SIGNUP_SUBMIT_URL,

    // TOPIC_GET_SINGLE_TOPIC_URL,
    TOPIC_GET_REPLY_URL: TOPIC_GET_REPLY_URL,
    TOPIC_GET_URL: TOPIC_GET_URL,
    TOPIC_CREATE_URL: TOPIC_CREATE_URL,
    SOCIAL_LOGIN_URL: SOCIAL_LOGIN_URL,
    RELATIVE_SOCIAL_LOGIN_URL: RELATIVE_SOCIAL_LOGIN_URL,
    REDPACK_STATUS_URL: REDPACK_STATUS_URL,
    REDPACK_RECORD_URL: REDPACK_RECORD_URL,
    REDPACK_SNATCH_URL: REDPACK_SNATCH_URL,
    CASH_DONATE_DETAIL_URL: CASH_DONATE_DETAIL_URL,
    GIFT_DETAIL_URL: GIFT_DETAIL_URL,
    DONATE_URL: DONATE_URL,
    RELATIVE_DONATE_URL: RELATIVE_DONATE_URL,
    FREE_GIFT_DONATE_URL: FREE_GIFT_DONATE_URL,
    PPT_GET_IMG_BY_PAGE_URL: PPT_GET_IMG_BY_PAGE_URL,

    COMMENT_IMAGE_NUM_REG: COMMENT_IMAGE_NUM_REG,
    COMMENT_TEXT_REG: COMMENT_TEXT_REG,

    SOCIAL_LOGIN_TYPE_ARRAY: SOCIAL_LOGIN_TYPE_ARRAY,

    AUTH_DOMAIN: AUTH_DOMAIN,
    USER_AUTH_START_SESSION: USER_AUTH_START_SESSION,
    USER_AUTH_GET_USER_INFO: USER_AUTH_GET_USER_INFO,
    USER_AUTH_ANONYMOUS: USER_AUTH_ANONYMOUS,
    USER_AUTH_LOGIN_BY_OTHER: USER_AUTH_LOGIN_BY_OTHER,
    STREAM_MULTI_RATE: STREAM_MULTI_RATE
};



/*****************
 ** WEBPACK FOOTER
 ** ./application/components/config.js
 ** module id = 117
 ** module chunks = 1
 **/